(function ( $ ) {

    $.fn.showDiscover = function() {
       	var target = this.data('target');
       	var delay = 50;
       	var items = $(target).find('.js-discover-item');
       	var number = items.length;
       	var that = this;


        return that.click(function(){
        	$(that).toggleClass('open');
        	if($(that).is('.open')) {
        		putDelay(items);
        		$(target).parent().velocity("slideDown", {
        			duration: 700,
        			easing: [ 0.670, 0.005, 0.360, 0.995 ],
        			complete: function() {
        				items.toggleClass('open');
        			}
        		});
                $('html, body').animate({
                    scrollTop: $(window).scrollTop() + 100
                }, 1200);
        	} else {
        		reverseDelay(items);
        		items.toggleClass('open');
        		$(target).parent().velocity("slideUp", {
        			delay: (number+1)*delay,
        			duration: 700,
        			easing: [ 0.670, 0.005, 0.360, 0.995 ],
        		});
        	};
        });


        function putDelay(elem) {
        	elem.each(function(index){
				item_delay = delay*index/1000;
       			$(this).css('transitionDelay', item_delay +'s');
        	});
        };

        function reverseDelay(elem) {
        	elem.each(function(index){
				item_delay = delay*Math.abs(index - number)/1000;
       			$(this).css('transitionDelay', item_delay +'s');
        	});
        };
    };
}( jQuery ));


$(function(){
	if ($('.js-open-discover').length) {
		$('.js-open-discover').showDiscover();
	}
    $('.js-next-magazines').on('click',function()
    {
        $('#otherADNbtn').trigger('click')
        $(this).hide();
        $('html, body').animate({
            scrollTop: $('#otherADNbtn').offset().top
        }, 1200);

    })

});
